
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M10 1a9 9 0 00-9 9v24.837a9 9 0 009 9h24.837a9 9 0 009-9V10a9 9 0 00-9-9H10z","stroke":"#504F4F","stroke-width":"2"}}),_c('path',{attrs:{"d":"M18.25 28.25c1.034 0 1.875.841 1.875 1.876 0 1.032-.84 1.874-1.874 1.874a1.877 1.877 0 01-1.875-1.874c0-1.033.84-1.875 1.875-1.875zm9.375 0a1.876 1.876 0 11-1.875 1.875c0-1.032.84-1.874 1.875-1.874zM18.25 29.5a.625.625 0 100 1.25.625.625 0 000-1.25zm9.374 0a.626.626 0 100 1.252.626.626 0 000-1.252zM15.75 24.499c0 .69.56 1.249 1.249 1.249v.001h13.75a.626.626 0 010 1.25H17a2.503 2.503 0 01-2.5-2.499c0-1.11.727-2.053 1.73-2.379l-2.218-8.87H12V12h2.99l2.498 10h12.686l.578-6.927-.003-.573H32v.626l-.676 8.123H17c-.688 0-1.25.561-1.25 1.25zm11.621-6.75a.626.626 0 010 1.25h-7.747a.625.625 0 010-1.25h7.747zm0-3a.626.626 0 010 1.25h-7.747a.625.625 0 010-1.25h7.747z","fill":"#BF9C5F","fill-rule":"nonzero"}})])])
          )
        }
      }
    